import _createForOfIteratorHelper from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper";
import _classCallCheck from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/och/Downloads/contentlab_frontend-main-1/node_modules/@babel/runtime/helpers/esm/createClass";
import { colorToRgb, getLinkColor } from "../../../Utils/ColorUtils";
import { drawLinkLine as _drawLinkLine, drawLinkTriangle as _drawLinkTriangle } from "../../../Utils/CanvasUtils";
import { getDistance, getRangeValue } from "../../../Utils/NumberUtils";
export var LinkInstance = /*#__PURE__*/function () {
  function LinkInstance(container) {
    _classCallCheck(this, LinkInstance);
    this.container = container;
  }
  _createClass(LinkInstance, [{
    key: "particleCreated",
    value: function particleCreated(particle) {
      var linkParticle = particle;
      linkParticle.links = [];
    }
  }, {
    key: "particleDestroyed",
    value: function particleDestroyed(particle) {
      var linkParticle = particle;
      linkParticle.links = [];
    }
  }, {
    key: "drawParticle",
    value: function drawParticle(context, particle) {
      var _this = this;
      var linkParticle = particle,
        container = this.container,
        particles = container.particles,
        pOptions = particle.options;
      if (linkParticle.links.length <= 0) {
        return;
      }
      context.save();
      var p1Links = linkParticle.links.filter(function (l) {
        var linkFreq = container.particles.getLinkFrequency(linkParticle, l.destination);
        return linkFreq <= pOptions.links.frequency;
      });
      var _iterator = _createForOfIteratorHelper(p1Links),
        _step;
      try {
        var _loop = function _loop() {
          var link = _step.value;
          var p2 = link.destination;
          if (pOptions.links.triangles.enable) {
            var links = p1Links.map(function (l) {
                return l.destination;
              }),
              vertices = p2.links.filter(function (t) {
                var linkFreq = container.particles.getLinkFrequency(p2, t.destination);
                return linkFreq <= p2.options.links.frequency && links.indexOf(t.destination) >= 0;
              });
            if (vertices.length) {
              var _iterator2 = _createForOfIteratorHelper(vertices),
                _step2;
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  var vertex = _step2.value;
                  var p3 = vertex.destination,
                    triangleFreq = particles.getTriangleFrequency(linkParticle, p2, p3);
                  if (triangleFreq > pOptions.links.triangles.frequency) {
                    continue;
                  }
                  _this.drawLinkTriangle(linkParticle, link, vertex);
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
            }
          }
          if (link.opacity > 0 && container.retina.linksWidth > 0) {
            _this.drawLinkLine(linkParticle, link);
          }
        };
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      context.restore();
    }
  }, {
    key: "drawLinkTriangle",
    value: function drawLinkTriangle(p1, link1, link2) {
      var _a;
      var container = this.container,
        options = container.actualOptions,
        p2 = link1.destination,
        p3 = link2.destination,
        triangleOptions = p1.options.links.triangles,
        opacityTriangle = (_a = triangleOptions.opacity) !== null && _a !== void 0 ? _a : (link1.opacity + link2.opacity) / 2;
      if (opacityTriangle <= 0) {
        return;
      }
      var pos1 = p1.getPosition(),
        pos2 = p2.getPosition(),
        pos3 = p3.getPosition();
      container.canvas.draw(function (ctx) {
        if (getDistance(pos1, pos2) > container.retina.linksDistance || getDistance(pos3, pos2) > container.retina.linksDistance || getDistance(pos3, pos1) > container.retina.linksDistance) {
          return;
        }
        var colorTriangle = colorToRgb(triangleOptions.color);
        if (!colorTriangle) {
          var linksOptions = p1.options.links,
            linkColor = linksOptions.id !== undefined ? container.particles.linksColors.get(linksOptions.id) : container.particles.linksColor;
          colorTriangle = getLinkColor(p1, p2, linkColor);
        }
        if (!colorTriangle) {
          return;
        }
        _drawLinkTriangle(ctx, pos1, pos2, pos3, options.backgroundMask.enable, options.backgroundMask.composite, colorTriangle, opacityTriangle);
      });
    }
  }, {
    key: "drawLinkLine",
    value: function drawLinkLine(p1, link) {
      var container = this.container,
        options = container.actualOptions,
        p2 = link.destination,
        pos1 = p1.getPosition(),
        pos2 = p2.getPosition();
      var opacity = link.opacity;
      container.canvas.draw(function (ctx) {
        var _a, _b;
        var colorLine;
        var twinkle = p1.options.twinkle.lines;
        if (twinkle.enable) {
          var twinkleFreq = twinkle.frequency,
            twinkleRgb = colorToRgb(twinkle.color),
            twinkling = Math.random() < twinkleFreq;
          if (twinkling && twinkleRgb) {
            colorLine = twinkleRgb;
            opacity = getRangeValue(twinkle.opacity);
          }
        }
        if (!colorLine) {
          var linksOptions = p1.options.links,
            linkColor = linksOptions.id !== undefined ? container.particles.linksColors.get(linksOptions.id) : container.particles.linksColor;
          colorLine = getLinkColor(p1, p2, linkColor);
        }
        if (!colorLine) {
          return;
        }
        var width = (_a = p1.retina.linksWidth) !== null && _a !== void 0 ? _a : container.retina.linksWidth,
          maxDistance = (_b = p1.retina.linksDistance) !== null && _b !== void 0 ? _b : container.retina.linksDistance;
        _drawLinkLine(ctx, width, pos1, pos2, maxDistance, container.canvas.size, p1.options.links.warp, options.backgroundMask.enable, options.backgroundMask.composite, colorLine, opacity, p1.options.links.shadow);
      });
    }
  }]);
  return LinkInstance;
}();